'use strict';
import {LocalStorage} from "../wrappers/LocalStorage";
import {Injectable} from "@angular/core";

@Injectable()
export class UserProvider {
    constructor(private localStorage: LocalStorage) { }

    user() {
        return this.localStorage.retrieve('user');
    }

    userFirstName() {
        return this.user().name.split(' ')[0];
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/providers/user.provider.ts